// extracted by mini-css-extract-plugin
export default {"flex":"VS","imgwrap":"WS","image":"XS","textinfo":"YS","producttitle":"ZS","bolder":"aT","block":"bT","info":"cT","moredetails":"eT","whitebox":"fT","old_price":"gT","discount":"hT"};
    if(module.hot) {
      // 1711394579507
      var cssReload = require("../../../../../node_modules/mini-css-extract-plugin/dist/hmr/hotModuleReplacement.js")(module.id, {"locals":true});
      module.hot.dispose(cssReload);
      
    }
  